import AppDispatcher from "../Dispatcher";
import EventEmitter from "events";
import { AppActionConstants } from "../Actions/AppActionConstants";
import _ from "lodash";

class PackagesDataStore extends EventEmitter {
	constructor() {
		super();

		this.packages = {
			data: [],
			config: [],
			errors: [],
			defaultSelection: null,
			navigate: false,
			filteredData: [],
			newPackage: null
		};

		/*
		Need to register all actions with the AppDispatcher
		*/

		AppDispatcher.register((action) => {
			switch (action.type) {
				case AppActionConstants.fetchPackages:
					const hierarchyData = this.updateExistingValues(action.value.data, action.value.config);
					this.packages.config = action.value.config;
					this.packages.data = hierarchyData;
					this.emit("packages_loaded");
					break;
				case AppActionConstants.fetchOnlyPackages:
					const onlyPacakageConfig = this.packages.config;
					const onlyPackageData = this.updateExistingValues(action.value, onlyPacakageConfig);
					this.packages.data = onlyPackageData;
					this.emit("packages_loaded");
					break;
				case AppActionConstants.createPackagesSuccess:
					this.packages.data = [...this.packages.data, action.value];
					this.packages.newPackage = action.value;
					if (action.duplicatePackage === true) {
						this.emit("duplicate_packages_success");
					} else {
						this.emit("packages_success");
					}
					break;
				case AppActionConstants.packageCreated:
					this.packages.data = [action.value, ...this.packages.data];
					break;
				case AppActionConstants.createPackagesFail:
					const errorObject = {};
					Object.values(action.value)?.[0]?.Object?.InputErrors?.forEach((error) => {
						Object.keys(error).forEach((dataKeyName) => {
							errorObject[dataKeyName] = [error[dataKeyName]];
						});
					});
					if (Object.values(action.value)?.[0]?.Object?.Errors) {
						errorObject.Errors = [Object.values(action.value)?.[0]?.Object?.Errors];
					}
					this.packages.errors = errorObject;
					if (action.duplicatePackage === true) {
						this.emit("duplicate_packages_fail");
					} else {
						this.emit("packages_fail");
					}
					break;
				case AppActionConstants.createAndAddChildSuccess:
					this.packages.data = [action.value, ...this.packages.data];

					const defaultLabel = action.value.PackageName_Friendly;
					const defaultValue = action.value.PackageID;
					const parentDefaultValue = { label: defaultLabel, value: defaultValue };
					this.packages.defaultSelection = parentDefaultValue;
					this.packages.navigate = action.navigate;
					this.emit("packages_success");
					break;
				case AppActionConstants.editPackageSuccess:
					this.packages.data.splice(action.row, 1, action.value);
					this.packages.data = [...this.packages.data];
					if (action.placementSuccess) {
						this.emit("edit_success");
					} else {
						this.emit("edit_success_placement_fail");
					}
					break;
				case AppActionConstants.editPackageFail:
					const editErrorObject = {};
					Object.keys(action.value).forEach((uniqueID) => {
						if (action.value[uniqueID] && action.value[uniqueID].Result === false) {
							action.value[uniqueID].Object.InputErrors.forEach((error) => {
								Object.keys(error).forEach((dataKeyName) => {
									editErrorObject[dataKeyName] = [error[dataKeyName]];
								});
							});
						}
					});
					this.packages.errors = editErrorObject;
					this.emit("edit_fail");
					break;
				case AppActionConstants.deletePackageSuccess:
					this.packages.data = action.value;
					if (action.placementsDeleted) {
						this.emit("delete_success_placement");
					} else if (!action.placementsDeleted) {
						this.emit("delete_success_no_placement");
					}
					break;
				case AppActionConstants.lockUnlockWorkbookBudgetSuccess:
					this.packages.data = this.packages.data.map((datum) => ({
						...datum,
						IsPrismaBudgetLocked: action.value.locked ? "True" : "False"
					}));
					this.emit("packages_lock_unlock_success");
					break;
				case AppActionConstants.sendPackagesToGCM:
					this.emit("packages_pushed_to_GCM");
					break;
				case AppActionConstants.postGCMFetchPackages:
					const postGCMData = this.updateExistingValues(action.value, this.packages.config);
					this.packages.data = postGCMData;
					this.emit("post_gcm_packages_fetched");
					break;
				default:
					break;
			}
		});
	}

	/*
	Getter function to return the current state
	*/
	getData = () => this.packages.data;
	getFilteredData = () => this.packages.filteredData;
	getConfig = () => this.packages.config;
	getErrors = () => this.packages.errors;
	getDefaultValue = () => this.packages.defaultSelection;
	getNavigate = () => this.packages.navigate;
	getNewPackage = () => this.packages.newPackage;
	setNavigate = () => {
		this.packages.navigate = false;
	};

	resetDefaultValue = () => {
		this.packages.defaultSelection = null;
	};

	resetPlacementErrors = () => {
		this.packages.errors = [];
		this.emit("package__errors__reset");
	};

	resetPackageData = () => {
		this.packages.config = [];
	};

	returnDataRow = (row) => {
		return this.packages.data[row] ? this.packages.data[row] : {};
	};

	returnFilteredDataRow = (row) => {
		return this.packages.filteredData[row] ? this.packages.filteredData[row] : {};
	};

	updateDataManually = (data, bundle) => {
		for (const key in bundle) {
			if (bundle[key].Result === true) {
				const newRow = this.getFilteredData().length !== 0 ? this.returnFilteredDataRow(key) : this.returnDataRow(key);
				if (newRow) {
					newRow.PackageName = bundle[`${key}`].Object.PackageName;
					newRow.UniqueID = bundle[`${key}`].Object.UniqueID;
					if (bundle[`${key}`].Object.ParentUniqueIDCode) {
						newRow.ParentUniqueIDCode = bundle[`${key}`].Object.ParentUniqueIDCode;
					}
					newRow.PackageID = bundle[`${key}`].Object.PackageID;
					newRow.ExternalSystemStatusID = bundle[`${key}`].Object.ExternalSystemStatusID;
					newRow.ExternalSystemResponse = bundle[`${key}`].Object.ExternalSystemResponse;
				} else {
					const existingRow = data.filter((lineItem) => lineItem.UniqueID === key);
					if (existingRow[0]) {
						existingRow[0].UniqueID = bundle[`${key}`].Object.UniqueID;
						existingRow[0].PackageName = bundle[`${key}`].Object.PackageName;
					}
				}
			}
		}
	};

	updateExistingValues = (data, config) => {
		const newData = data;
		const fieldNames = {};
		const fieldIds = {};
		// const allConfigfields = [];
		const excludedFieldNames = [
			"CampaignID",
			"UniqueID",
			"TaxonomyData",
			"MetaData",
			"PackageName",
			"PackageID",
			"ExternalSystemResponse",
			"ExternalSystemResponse_Orig",
			"ExternalSystemStatusID",
			"IsArchived",
			"IsDeleted",
			"UpdatedBy"
		];
		config.TaxonomyData.forEach((taxonomyField) => {
			fieldNames[taxonomyField.Name] = taxonomyField.ID;
			fieldIds[taxonomyField.ID] = taxonomyField.Name;
			// allConfigfields.push(taxonomyField);
		});
		config.MetaData.forEach((metadataField) => {
			fieldNames[metadataField.Name] = metadataField.ID;
			fieldIds[metadataField.ID] = metadataField.Name;
			// allConfigfields.push(metadataField);
		});
		config.PackageData.forEach((placementField) => {
			fieldNames[placementField.Name] = placementField.ID;
			fieldIds[placementField.ID] = placementField.Name;
			// allConfigfields.push(placementField);
		});
		newData.forEach((dataField) => {
			if (!_.isEmpty(dataField)) {
				Object.keys(dataField).forEach((dataKeyName) => {
					if (!excludedFieldNames.includes(dataKeyName) && !Object.keys(fieldNames).includes(dataKeyName)) {
						let matchingId = null;
						if (dataField.TaxonomyData !== "") {
							JSON.parse(dataField.TaxonomyData).forEach((dataTaxonomyField) => {
								if (matchingId !== null) {
									return;
								}
								if (dataTaxonomyField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
									matchingId = dataTaxonomyField.DataKeyID;
								}
							});
						}
						if (matchingId === null) {
							if (dataField.MetaData !== "") {
								JSON.parse(dataField.MetaData).forEach((dataMetaDataField) => {
									if (matchingId !== null) {
										return;
									}
									if (dataMetaDataField.DataKeyShortDescr.split(" ").join("") === dataKeyName) {
										matchingId = dataMetaDataField.DataKeyID;
									}
								});
							}
						}
						if (matchingId !== null) {
							if (fieldIds[matchingId]) {
								dataField[fieldIds[matchingId]] = dataField[dataKeyName];
							}
						}
					}
					// Updates previous field name to newest one if there is a mismatch with latest config. Primarily for proper display in the sheet
					// if (Object.keys(fieldNames).includes(dataKeyName)) {
					// 	let fieldFound = false;
					// 	if (dataField.TaxonomyData !== '') {
					// 		JSON.parse(dataField.TaxonomyData).forEach(savedTaxonomyDataField => {
					// 			if (fieldFound === false) {
					// 				if (savedTaxonomyDataField.DataKeyShortDescr.split(' ').join('') === dataKeyName) {
					// 					fieldFound = true;
					// 					if (savedTaxonomyDataField?.DataValue?.DataValueID) {
					// 						const matchingConfigDataKey = allConfigfields.find(configField => {
					// 							return configField.ID === savedTaxonomyDataField?.DataKeyID;
					// 						});
					// 						if (matchingConfigDataKey && matchingConfigDataKey.Options) {
					// 							const matchingConfigOption = matchingConfigDataKey.Options.find(option => {
					// 								return option.OptionID === savedTaxonomyDataField.DataValue.DataValueID.toString();
					// 							});
					// 							if (matchingConfigOption && matchingConfigOption.OptionLabel !== dataField[dataKeyName]) {
					// 								dataField[dataKeyName] = matchingConfigOption.OptionLabel;
					// 							}
					// 						}
					// 					}
					// 				}
					// 			}
					// 		});
					// 	}
					// 	if (dataField.MetaData !== '') {
					// 		JSON.parse(dataField.MetaData).forEach(savedMetaDataField => {
					// 			if (fieldFound === false) {
					// 				if (savedMetaDataField.DataKeyShortDescr.split(' ').join('') === dataKeyName) {
					// 					fieldFound = true;
					// 					if (savedMetaDataField?.DataValue?.DataValueID) {
					// 						const matchingConfigDataKey = allConfigfields.find(configField => {
					// 							return configField.ID === savedMetaDataField?.DataKeyID;
					// 						});
					// 						if (matchingConfigDataKey && matchingConfigDataKey.Options) {
					// 							const matchingConfigOption = matchingConfigDataKey.Options.find(option => {
					// 								return option.OptionID === savedMetaDataField.DataValue.DataValueID.toString();
					// 							});
					// 							if (matchingConfigOption && matchingConfigOption.OptionLabel !== dataField[dataKeyName]) {
					// 								dataField[dataKeyName] = matchingConfigOption.OptionLabel;
					// 							}
					// 						}
					// 					}
					// 				}
					// 			}
					// 		});
					// 	}
					// }
				});
			}
		});
		return newData;
	};
}

export default new PackagesDataStore();
